
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ActivitySettingsCard from './TabNotifications/ActivitySettingsCard';

@Component({
  components: {
    ActivitySettingsCard,
  },
})
export default class TabNotifications extends Vue {
}
